export function textContainer (dimensions, offset) {
  // Determine the width and height of the sides of the parallelogram
  const width = dimensions.width - offset
  const height = Math.sqrt(Math.pow(offset, 2) + Math.pow(dimensions.height, 2))

  if (width > height) {
    // The width of the rectangle is the base width of the parallelogram minus twice the offset
    // This calculation ensures the rectangle's width is within the parallelogram's sloped sides
    const w = dimensions.width - 2 * offset
    return {
      width: w,
      height: dimensions.height,
      center: [offset + w / 2, dimensions.center[1]],
    }
  } else {
    // The height of the rectangle is half the height of the parallelogram
    // This calculation ensures the rectangle's height is within the parallelogram's sloped sides
    const w = dimensions.width - 1.5 * offset
    const h = dimensions.height * .5
    return {
      width: w,
      height: h,
      center: [dimensions.center[0], dimensions.center[1]],
    }
  }
}
